import Link from 'next/link'
import React from 'react'
import { Documents, Pdf, Xls, Xml } from '../../atoms/NewIcons'
import { getFileNameFromUrl, trackingDownload } from '../../../utils/gtm'

const DocumentoCard = ({ documento }) => {
  const estensione = documento.file_url ? documento.file_url.split('.')[1] : null

  return (
    <Link legacyBehavior href={documento.file_url}>
      <a
        target="_blank"
        className="documento-card"
        onClick={() => {
          trackingDownload(
            'altri_documenti',
            getFileNameFromUrl(documento.file_url) ?? documento?.nome
          )
        }}
      >
        <span className="documento-card__icon">
          {estensione == 'pdf' ? (
            <Pdf />
          ) : estensione == 'xml' ? (
            <Xml />
          ) : estensione == 'xls' ? (
            <Xls />
          ) : (
            <Documents />
          )}
        </span>
        <div className="documento-card__title">
          <strong>{documento.nome}</strong>
        </div>
      </a>
    </Link>
  )
}

export default DocumentoCard
